import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

const StatusList = Loadable(
  lazy(() =>
    import("./statusList").then(({ StatusList }) => ({
      default: StatusList,
    })),
  ),
);

export const StatusRoutes = [
  {
    path: "/enr-status",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[]} allowFullAccess>
        <StatusList />
      </AuthorizedRoute>
    ),
  },
];
